var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-information" },
    [
      _c(
        "div",
        { staticClass: "company-information__columns" },
        [
          _c(
            "Card",
            [
              _c("Heading", {
                attrs: {
                  labelTitle: _vm.$t.__(
                    "CompanyInformation.legal_information.title"
                  ),
                  variant: "h2",
                  prefixColoredIcon: {
                    icon: "building-skyscraper",
                    color: "brand"
                  }
                }
              }),
              _vm._v(" "),
              _vm.isLoading
                ? _c("CompanyInformationLoader")
                : [
                    _vm.companyInformationLocked
                      ? _c("CompanyInformationFormLocked", {
                          attrs: {
                            data: _vm.companyInformation,
                            countries: _vm.countries
                          }
                        })
                      : _c("CompanyInformationForm", {
                          attrs: {
                            data: _vm.companyInformation,
                            countries: _vm.countries
                          }
                        })
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "Card",
            [
              _c("Heading", {
                attrs: {
                  labelTitle: _vm.$t.__(
                    "CompanyInformation.contact_information.title"
                  ),
                  variant: "h2",
                  prefixColoredIcon: { icon: "user-hexagon", color: "brand" }
                }
              }),
              _vm._v(" "),
              _vm.isLoading
                ? [_c("CompanyInformationLoader")]
                : _c("CompanyContactForm", {
                    attrs: { data: _vm.companyInformation }
                  })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Card",
        [
          _c(
            "div",
            { staticClass: "company-information__address-card-header" },
            [
              _c("Heading", {
                attrs: {
                  labelTitle: _vm.$t.__("CompanyInformation.addresses.title"),
                  variant: "h2",
                  prefixColoredIcon: { icon: "location", color: "brand" }
                }
              }),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("CompanyInformation.addresses.button"),
                  type: "secondary",
                  disabled: _vm.isPanelOpen
                },
                on: { click: _vm.handleAddAddress }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassAlert", {
            attrs: {
              type: "neutral",
              description: _vm.$t.__("CompanyInformation.addresses.alert"),
              customIcon:
                "/ressources/logged/img/icon/svg/info-e-invoicing.svg",
              showClose: false
            }
          }),
          _vm._v(" "),
          _c("CompanyInformationAddressList", {
            attrs: {
              addresses: _vm.addresses,
              loading: _vm.isLoading,
              isPanelOpen: _vm.isPanelOpen
            },
            on: {
              delete: _vm.refreshAddresses,
              update: _vm.refreshAddresses,
              panelOpen: function($event) {
                _vm.isPanelOpen = true
              },
              panelClose: function($event) {
                _vm.isPanelOpen = false
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }